import { useState, useEffect, useRef } from 'react';
import { loadImageAsBlob } from '@/utils/imageLoader';

interface AvatarImageProps {
  src?: string | null;
  alt: string;
  className?: string;
  fallback: React.ReactNode;
}

export default function AvatarImage({
  src,
  alt,
  className = 'w-full h-full object-cover',
  fallback,
}: AvatarImageProps) {
  const [imageSrc, setImageSrc] = useState<string | null>(null);
  const [showImage, setShowImage] = useState(false);
  const blobUrlRef = useRef<string | null>(null);

  useEffect(() => {
    if (!src) {
      setShowImage(false);
      return;
    }

    // Use the shared image loader with unified cache
    loadImageAsBlob(src)
      .then((url) => {
        if (url) {
          setImageSrc(url);
          setShowImage(true);
          if (url.startsWith('blob:')) {
            blobUrlRef.current = url;
          }
        } else {
          setShowImage(false);
        }
      })
      .catch(() => {
        setShowImage(false);
      });
  }, [src]);

  if (!showImage) {
    return fallback;
  }

  return (
    <img
      src={imageSrc || src || ''}
      alt={alt}
      className={className}
      onError={() => setShowImage(false)}
    />
  );
}
